 

<template>
  <v-app id="login">
    <v-content class="primary">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <v-responsive>
                  <div class="layout column align-center" style="padding:30px;">
                    <img src="@/assets/sentinelaoclogo.png" alt="Smartoffer - Sentinela"  style="width:100%;heigth:10%">
                  </div>
                </v-responsive>
                <v-form>
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                   placeholder="Login"
                   solo
                    type="text"
                    v-model="model.username"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    solo
                    placeholder="Password"
                    id="password"
                    type="password"
                    v-model="model.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn dark block color="primary" @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
            <v-snackbar
            :timeout="3000"
            bottom
            right
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon> 
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>    
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import UserService from '@/services/UserService'
import Vue from 'vue'
export default {
  data: () => ({
    loading: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    model: {
      username: "",
      password: ""
    }
  }),
  beforeMount() {
    if (localStorage.getItem("jwt") != null) {
      if (this.$route.query.from != null) {
        //this.$router.push(this.$route.params.nextUrl);
        this.$router.push(this.$route.query.from);
      } else {
        this.$router.push("/ordencompraingreso");
      }
    }
  },
  methods: {
      
    login() {
       debugger;
      let self = this;
      let data = { UserName: this.model.username, Password: this.model.password };
       if(this.model.username.trim().length == 0 || this.model.password.trim().lenght == 0){ return;}

     
      self.loading = true;
      UserService
        .login(data)
        .then(r => {
          debugger;
          console.log(r);
          self.loading = false;
          localStorage.setItem('user', this.model.username); 
          localStorage.setItem('userSignalR', this.model.username); 
          localStorage.setItem('namefull', r.data.user.nameFull); 
          localStorage.setItem('jwt', r.data.token); 
          localStorage.setItem('refreshToken', r.data.refreshToken); 
          localStorage.setItem('rol', r.data.user.rol);
          localStorage.setItem('clienteid', r.data.clienteValido);
          localStorage.setItem('cliente', r.data.nombreClienteValido);
          localStorage.setItem('tieneCM', r.data.tieneCM);
          localStorage.setItem('tieneOC', r.data.tieneOC);
          this.$store.commit('SET_CURRENT_USER',r.data.user.nameFull);
          this.$store.commit('SET_CURRENT_CLIENTE',r.data.nombreClienteValido);
           this.$store.commit('SET_CURRENT_CLIENTEID',r.data.clienteValido);
           this.$store.dispatch('setCurrentClienteId', r.data.clienteValido);
           this.$store.commit('SET_CURRENT_VERCM',r.data.tieneCM);
            this.$store.commit('SET_ROL',r.data.user.rol);
         // localStorage.setItems('menu', self.menu);
          if (localStorage.getItem("jwt") != null) {

             Vue.prototype.startSignalR(localStorage.getItem("jwt")) 
              this.$store.commit('SAVE_SIGNALR',localStorage.getItem("jwt"));
              this.$store.dispatch('setSignalR', localStorage.getItem("jwt"));
              debugger;
             /* var datosUser = UserService.getUserInfo().then(dd => {
                console.log(dd)
               } );*/


            if (this.$route.query.from != null) {
              //this.$router.push(this.$route.params.nextUrl);
              this.$router.push(this.$route.query.from);
            } else {
              this.$router.push("/ordencompraingreso");
               
            }
           }
        })
        .catch(r => {     
          console.log(r.response);             
           this.snackbar = {
            show: true,
            color: 'red',
            text: r.response.data
          }; 
          
          self.loading = false;
        });
 
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style> 
 